import { Flex, FlexProps, Tooltip } from '@chakra-ui/react'
import React from 'react'

export interface DataCellProps extends FlexProps {
  index?: number
  title?: string
  withTooltip?: string | null
}

export const DataCell: React.FC<DataCellProps> = ({ children, title, withTooltip, ...props }) => {
  const body = (
    <Flex
      title={withTooltip ? undefined : title}
      p={1}
      fontSize="md"
      align="center"
      // background={getRowBackground(index)}
      {...props}>
      {children}
    </Flex>
  )
  return withTooltip ? (
    <Tooltip lineHeight={1.2} py={1} placement="top" bg="gray.500" hasArrow label={withTooltip}>
      {body}
    </Tooltip>
  ) : (
    body
  )
}
